import { useEffect, useState } from 'react'

export type Route = 'home' | 'pricing'

function readRoute(): Route {
  return window.location.hash.startsWith('#/pricing') ? 'pricing' : 'home'
}

export function useHashRoute(): Route {
  const [route, setRoute] = useState<Route>(readRoute)

  useEffect(() => {
    const handleHashChange = () => {
      const next = readRoute()
      setRoute((prev) => {
        if (prev !== next) window.scrollTo({ top: 0 })
        return next
      })
    }
    window.addEventListener('hashchange', handleHashChange)
    return () => window.removeEventListener('hashchange', handleHashChange)
  }, [])

  return route
}
